import { toast } from 'react-toastify';
import { fetchWithToken } from '../apiauth/apiUtils';
import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface ReferralRecord {
  id: number;
  userName: string;
  email: string;
  phoneNumber: string;
  status: boolean;
}

export interface UserReferalDetailsResponse {
  userId: number;
  referredBy: string | null;
  referralCount: number;
  referrals: ReferralRecord[];
}

export const getReferalDetails = async (
  userId: number,
  t: (key: string) => string
): Promise<UserReferalDetailsResponse> => {
  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetchWithToken(
      `${baseUrl}/api/User/GetReferalDetailsAsync?userId=${userId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch referal details`);
    }

    const data: UserReferalDetailsResponse = await response.json();
    return data;
  } catch (error) {
    toast.error(t("referalDetailsError"));
    throw error;
  }
};
